<template>
  <div
    class="followup-module"
    :class="{ isEnglish: $isEnglish }"
  >
    <!-- 设置回访提醒 -->
    <div
      v-if="permissionInfo.is_add_remind"
      class="set-remind border-bottom-1px"
    >
      <div class="edit">
        <div class="top clearfix">
          <span class="label">{{ $t('message["447"]') }}</span>
          <!-- 回访提醒时间 -->
          <span
            v-if="followup.remind.time"
            class="time"
          >{{ followup.remind.time }}</span>
          <div
            class="btns"
            :class="{'set-btns':!followup.remind.time}"
          >
            <!-- 修改按钮 -->
            <span
              v-if="followup.remind.time"
              class="btn-text"
              @click="handleSetRemindModal"
            > {{ $t('message["1388"]') }}</span>
            <!-- 清除按钮 -->
            <span
              v-if="followup.remind.time"
              class="btn-text"
              @click="clearRemind"
            >{{ $t('message["734"]') }}</span>
            <!-- 设置按钮 -->
            <span
              v-if="!followup.remind.time"
              class="btn-text set-btn"
              @click="handleSetRemindModal"
            >{{ $t('message["1008"]') }}<i class="iconfont iconicon-test18 arrow" /></span>
          </div>
        </div>
        <!-- 回访提醒内容 -->
        <div
          v-if="followup.remind.time"
          class="remind-content"
        >
          <p class="content">
            {{ followup.remind.content }}
          </p>
        </div>
      </div>
    </div>
    <!-- 下次回访时间 -->
    <div
      v-if="next_followup_time"
      class="next_followup_time tip border-bottom-1px"
    >
      <span class="label">{{ $t('message["1293"]') }}</span>
      <span class="value">{{ $moment(next_followup_time * 1000).format('YYYY-MM-DD HH:mm:ss') }}</span>
    </div>
    <!-- 回访记录列表 -->
    <div class="list-box">
      <h2 class="return-record">
        {{ $t('message["441"]') }}
      </h2>
      <ul v-if="followup.list && followup.list.length">
        <li
          v-for="(item, index) in followup.list"
          :id="`followupLi${item.id}`"
          :key="item.id"
        >
          <div
            v-if="item.is_show_xiaoman"
            class="top"
          >
            <!-- 同步至小满按钮 -->
            <a
              v-if="item.is_show_xiaoman"
              class="assoc-btn btn-text"
              @click="assocFollowup(item, index)"
            >{{ '同步至小满' }}</a>
            <a
              v-if="item.is_synced_xiaoman"
              class="assoc-btn btn-text disabled"
            >{{ '已同步至小满' }}</a>
            <!-- 删除回访按钮 -->
            <a
              v-if="permissionInfo.is_del_followups"
              class="del-btn btn-text"
              @click="delFollowup(item, index)"
            >{{ $t('message["962"]') }}</a>
          </div>
          <div class="info">
            <span class="time clearfix">
              {{ moment(item.uptime * 1000).format(dateFormat) }}
              <a
                v-if="permissionInfo.is_del_followups && !item.is_show_xiaoman"
                class="del-btn btn-text fr"
                @click="delFollowup(item, index)"
              >{{ $t('message["962"]') }}</a>
            </span>
            <span class="name">{{ item.truename }}</span>
          </div>
          <!-- 回访内容 -->
          <div
            class="content"
          >
            {{ item.content }}
          </div>
          <!-- 图片预览 -->
          <a
            v-for="(file, i) in item.pics"
            :key="i"
            class="file"
            @click="handleclickGallery(item.pics, i)"
          ><i class="iconfont iconpic" /> {{ file.file_name }}</a>
          <!-- 回访记录操作按钮 -->
          <div
            v-if="permissionInfo.is_add_followups"
            class="operate-btns"
          >
            <span
              class="mesage"
              @click="handleReply(item, index)"
            >
              <i class="iconfont iconcomment" />{{ (item.replys && item.replys.length) || $t('message["449"]') }}
            </span>
          </div>
        </li>
      </ul>
      <div
        v-else
        class="fs-gray list-empty"
        @click="openAddReturnVisitModal"
      >
        <!-- 暂无回访记录 -->
        {{ $t('message["1546"]') }}
        <i
          v-if="permissionInfo.is_add_followups"
          class="iconfont iconicon-test18 arrow"
        />
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/lib/eventBus'
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  data () {
    return {
      next_followup_time: '',
      dateFormat: 'YYYY-MM-DD HH:mm',
      confirmLoading: false
    }
  },
  computed: {
    ...mapState('inquery/detailData', [
      'followup',
      'detailData'
    ]),
    ...mapGetters('inquery/detailData', ['permissionInfo']),
    inquiryId () {
      return this.$route.params.inquiryId
    },
    followupid () {
      return this.$route.query.followupid
    },
    replyid () {
      return this.$route.query.replyid
    }
  },

  async created () {
    await this.getFollowupList()
    this.$bus.$on('getFollowupList', this.getFollowupList)
  },

  destroyed () {
    eventBus.$off('getFollowupList')
  },

  methods: {
    moment,
    ...mapActions('inquery/detailData', [
      'fetchFollowupList',
      'inquiryDelFollowup',
      'inquiryDelRemind',
      'followupSyncxiaoman'
    ]),
    async getFollowupList () {
      const chain = await this.fetchFollowupList()
      chain
        .params({
          inquiryid: this.inquiryId
        })
        .onSuccess((res = {}) => {
          this.next_followup_time = res.extend && res.extend.next_followup_time
          if (this.followup.list && this.followup.list.length) {
            let id = 'followupLi' + this.followupid
            let $currFollowupLi = document.getElementById(id)
            setTimeout(() => {
              $currFollowupLi && $currFollowupLi.scrollIntoView(false)
            }, 30)
          }
        })
        .fetch()
    },
    /* 设置/修改 回访提醒 */
    handleSetRemindModal () {
      eventBus.$emit('openSetRemindModal')
    },
    /* 进入 新增回访 页面 */
    openAddReturnVisitModal () {
      if (!this.permissionInfo.is_add_followups) return

      this.$router.push({
        query: {
          ...this.$route.query,
          tab: 'addFollowup'
        }
      })
    },

    async clearRemind () {
      const chain = await this.inquiryDelRemind()
      chain
        .params({
          inquiryid: this.inquiryId
        })
        .fetch()
    },

    delFollowup (item, index) {
      this.$createDialog({
        type: 'confirm',
        icon: 'cubeic-alert',
        title: this.$t('message["492"]'),
        content: this.$t('message["442"]') + '？',
        confirmBtn: {
          text: this.$t('message["915"]'),
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: this.$t('message["896"]'),
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: async () => {
          const chain = await this.inquiryDelFollowup()
          chain
            .params({
              inquiryid: this.inquiryId,
              followupid: item.id
            })
            .onSuccess(res => {
              this.getFollowupList()
            })
            .fetch()
        }
      }).show()
    },

    async assocFollowup (item, index) {
      if (item.is_synced_xiaoman) return
      if (this.confirmLoading) return

      this.confirmLoading = true

      let chain = await this.followupSyncxiaoman({
        inquiryid: this.inquiryId,
        followupid: item.id
      })
      chain.onSuccess(res => {
        item.is_synced_xiaoman = 1
        item.is_show_xiaoman = 0
        this.confirmLoading = false
      })
    },

    handleReply (item, index) {
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: 'followupReply',
          followupid: item.id
        }
      })
    },

    handleclickGallery (fileList, i) {
      let item = fileList[i]
      if (item.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: this.$t('message["1099"]') + '？',
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          centered: true,
          // closable: true,
          onOk: () => {
            // window.open(item.url || item.file_url)
            this.$downloadFile(item.url || item.file_url)
          }
        })
      } else {
        this.$bus.$emit('getFileGallery', fileList, i)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.followup-module {
  .set-remind {
    background-color: #fff;
    .edit {
      padding: 16px 0;
      .top {
        padding: 0 12px;
        line-height: 24px;
      }
      .label {
        display: inline-block;
        width: 100px;
        color: #888;
      }
      .btns {
        float: right;
        &.set-btns {
          width: 251px;
        }
      }
      .btn-text {
        margin-left: 11px;
        color: $primary-color;
      }
      .set-btn {
        width: 251px;
        display: flex;
        justify-content: space-between;
        margin-left: 0;
        color: #d6d6d6;
      }
      .remind-content {
        padding: 0 12px;
        .content {
          padding-top: 12px;
          padding-left: 100px;
          line-height: 24px;
          color: $gray2;
          font-size: 16px;
          word-break: break-all;
        }
      }
    }
  }

  .tip {
    display: flex;
    padding: 16px 12px;
    background-color: #fff;
    .label {
      display: inline-block;
      width: 100px;
      padding-right: 26px;
      line-height: 24px;
      color: #888;
    }
    .value {
      align-self: center;
      color: #ffab3b;
    }
  }
  .list-box {
    display: flex;
    padding: 16px 12px;
    background-color: #fff;
    .return-record {
      width: 100px;
      color: #888;
      line-height: 24px;
    }
    ul {
      width: 251px;
      background-color: #fff;
    }
    li {
      padding: 16px 0;
      line-height: 24px;
      background-color: #fff;
      border-bottom: solid 1px $gray4;
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        border: none;
        padding-bottom: 0;
      }
    }
    .top {
      text-align: right;
    }
    .top, .info {
      margin-bottom: 12px;
      font-size: 16px;
    }
    .assoc-btn {
      margin: 12px;
    }
    .assoc-btn.disabled {
      opacity: .5;
    }
    .time {
      display: block;
      margin-right: 8px;
      margin-bottom: 8px;
    }
    .name {
      display: block;
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-right: 8px;
    }
    .content {
      line-height: 24px;
      color: #333;
      font-size: 16px;
      word-break: break-all;
    }
    a.file {
      display: block;
      margin: 10px 0;
      line-height: 24px;
      /* text-overflow: ellipsis;
      overflow: hidden; */
      word-break: break-all;
      &:last-child {
        margin-bottom: 0;
      }
      .iconpic {
        color: #dbdbdb;
      }
    }
    .list-empty {
      display: flex;
      justify-content: space-between;
      flex: 1;
      // padding: 0 12px;
      line-height: 24px;
      color: #d6d6d6;
      font-size: 16px;
      background: #fff;
    }
  }
  .operate-btns {
    height: 32px;
    line-height: 32px;
    margin-top: 12px;
    text-align: right;
    color: #d6d6d6;
    .iconfont {
      margin-right: 5px;
    }
  }
}
.isEnglish{
  .set-remind .edit .btn-text {
    margin-left: 6px;
    &.set-btn{
      margin-left: 0;
    }
  }
}
</style>
